var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.65,
    height: 20.65,
    viewBox: "0 0 20.65 20.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_link",
    transform: "translate(0.45 0.45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_66",
    "data-name": "\\uC120 66",
    y1: 7.482,
    x2: 7.482,
    transform: "translate(10.788 1.48)",
    fill: "none",
    stroke: "#4a506b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_136",
    "data-name": "\\uD328\\uC2A4 136",
    d: "M20.33,5.13V.75H15.95",
    transform: "translate(-1.33 0)",
    fill: "none",
    stroke: "#4a506b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_137",
    "data-name": "\\uD328\\uC2A4 137",
    d: "M8.963.75H7.138C2.575.75.75,2.575.75,7.138v5.475C.75,17.175,2.575,19,7.138,19h5.475C17.175,19,19,17.175,19,12.613V10.788",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#4a506b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLink);
export default __webpack_public_path__ + "static/media/ico_link.03088d26edfe7182f9b5cea2563ac6b4.svg";
export { ForwardRef as ReactComponent };